import React from 'react';
import { GuidePageUpsellCardsMetaData } from 'app/common/react/components/growth/unauth/UnauthGuidePage/constants';
import { Box, Heading } from 'gestalt';

const GUIDEPAGE_UPSELL_BLP_CARD_WIDTH = 236;
const GUIDEPAGE_UPSELL_BLP_CARD_HEIGHT = 118;
const GUIDEPAGE_UPSELL_BLP_CONTAINER_WIDTH = GUIDEPAGE_UPSELL_BLP_CARD_WIDTH;
const GUIDEPAGE_UPSELL_BLP_CONTAINER_HEIGHT =
  GUIDEPAGE_UPSELL_BLP_CARD_HEIGHT * GuidePageUpsellCardsMetaData.length +
  8 * (GuidePageUpsellCardsMetaData.length - 1);

const styles = {
  upsellText: {
    top: 0,
    left: 0,
    position: 'absolute',
    width: '236px',
    height: '118px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4))',
  },
  img: {
    objectFit: 'cover',
    borderRadius: '8px',
    width: `${GUIDEPAGE_UPSELL_BLP_CARD_WIDTH}px`,
    height: `${GUIDEPAGE_UPSELL_BLP_CARD_HEIGHT}px`,
  },
};

const renderBLPUpsellCard = (upsellCard) => (
  <Box
    marginBottom={2}
    width={GUIDEPAGE_UPSELL_BLP_CARD_WIDTH}
    height={GUIDEPAGE_UPSELL_BLP_CARD_HEIGHT}
  >
    <a href={upsellCard.link} alt={`Halloween ${upsellCard.name}`}>
      <Box shape="rounded" position="absolute">
        <img
          alt={upsellCard.name}
          style={styles.img}
          src={upsellCard.imgUrlBlp || upsellCard.imgUrl}
        />
        <div style={styles.upsellText}>
          <Heading color="white" size="xs">
            {upsellCard.blpName}
          </Heading>
        </div>
      </Box>
    </a>
  </Box>
);

export const UnauthGuidePageUpsellInBoardPage = () => (
  <Box height={GUIDEPAGE_UPSELL_BLP_CONTAINER_HEIGHT} width={GUIDEPAGE_UPSELL_BLP_CONTAINER_WIDTH}>
    {GuidePageUpsellCardsMetaData.map((cardContent) => renderBLPUpsellCard(cardContent))}
  </Box>
);

export default UnauthGuidePageUpsellInBoardPage;
